import MyDiv from './pages.style'
import { Box, Flex, Input, InputGroup, InputLeftElement, Text, Image, TableContainer, Table, Th, Thead, Tr, Tbody, Td, Button, Tooltip, Grid, GridItem, Center, Spinner } from '@chakra-ui/react';
import { DeleteIcon, Search2Icon } from '@chakra-ui/icons';
import { ActionEditIcon, CustomButton, CustomTable, CustomToast } from '../../../../components';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as routesNames from '../../../../constants/routes';
import AlertCard from '../../../../components/AlertCard/alertCard';
import { useFetch } from '../../../../hooks/useFetch';
import { Header, IPage } from './model';
import CustomPagination from '../../../../components/CustomPagination/customPagination';
import { Column } from '../../../../components/CustomTable/customTable';


const Pages = () => {
    const [data, setData] = useState<IPage[]>([]);
    const [deleteId, setDeleteId] = useState<number[]>([]);
    const [deleteAlert, setDeleteAlert] = useState(false);
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 20, page: 0, sortField: '', sortOrder: 1, });
    const [totalCount, setTotalCount] = useState<number>(0);
    const pageCount = Math.ceil(totalCount / lazyParams.rows);


    const loadPages = async (filterValue = '') => {
        const query = new URLSearchParams({
            lazyParams: JSON.stringify(lazyParams),
            search: filterValue,
        }).toString();

        const endpoint = query ? `page?${query}` : 'page';
        const pages = await fetchApi<any>(endpoint, "GET", null, null, '');
        if (pages) setData(pages.result);
        setTotalCount(pages.totalcount);
    };


    useEffect(() => {
        loadPages(searchQuery);
    }, [lazyParams, searchQuery]);

    const handleDelete = (id: any) => {
        setDeleteId([...deleteId, id])
        setDeleteAlert(true)
    };
    const confirmDelete = () => {
        fetchApi(`page/${deleteId[0]}`, 'DELETE', null, null, 'Page deleted successfully')
        setDeleteAlert(false)
    };

    const handleEdit = (page: IPage) => {
        page.features?.forEach((feature) => {
            feature.state = 'update';
        });
        navigate(routesNames.NEWPAGE, {
            state: {
                data: page,
                isEditing: true
            }
        });
    };

    // useEffect(() => {
    //     const delayDebounce = setTimeout(() => {
    //         loadPages(searchQuery);
    //     }, 700);

    //     return () => clearTimeout(delayDebounce);
    // }, [searchQuery]);



    const handlePageClick = ({ selected }: { selected: number }) => {
        const updatedParams = {
            ...lazyParams,
            page: selected,
            first: selected * lazyParams.rows,
        };
        setLazyParams(updatedParams);
    };


    return (
        <MyDiv>
            <Box className="page_wrapper">
                <Flex className="page_heading flex_header" >
                    <Text className="font-poppins text_semibold text_3xl">Pages</Text>
                    <Flex gap={2}>
                        <InputGroup width="197px" height="37px">
                            <InputLeftElement pointerEvents="none">
                                <Search2Icon color="rgba(102, 112, 133, 1)" />
                            </InputLeftElement>
                            <Input type="text" className='font-poppins text_regular text_md' placeholder="Search Page Name...." maxW="400px" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                        </InputGroup>
                        <CustomButton onClick={() => navigate(routesNames.NEWPAGE)} title="Add New" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} />
                    </Flex>
                </Flex>
                <Box mt={4} overflowX="auto" borderRadius="md" boxShadow="sm" bg="#fff">
                    <Grid className='grid_container'>
                        <GridItem colSpan={12}>
                            <Box position="relative" minH="300px">
                                {loading ? (
                                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                                    </Center>) : (
                                    <>
                                         <CustomTable value={data}>
                                        <Column header="S. No" body={(_, index) => index + 1} />
                                        <Column header="Page Name" field='name' />
                                        <Column header="Label" field='label' />
                                        <Column
                                            header="Description"
                                            body={(page:any) => (
                                                <Tooltip label={page.description} aria-label="Full description" bg="gray.700" color="white" placement="bottom-start" maxW="300px" hasArrow>
                                                    <Text isTruncated maxW='8vw'>{page.description}</Text>
                                                </Tooltip>
                                            )}
                                        />
                                        <Column header="URL" field='url' />
                                        <Column
                                            header="Edit"
                                            body={(page:any) => (
                                                <ActionEditIcon onClick={() => handleEdit(page)} cursor="pointer" />
                                            )}
                                        />
                                        <Column
                                            header="Action"
                                            body={(page:any) => (
                                                 <Button size="sm" className='del font-poppins text_regular text_sm' leftIcon={<DeleteIcon />} onClick={() => handleDelete(page.id)}>Delete</Button>
                                            )}
                                        />
                                    </CustomTable>
                                    </>)}
                            </Box>
                        </GridItem>
                    </Grid>
                </Box>
                <AlertCard onClose={() => setDeleteAlert(false)} onConfirm={confirmDelete} isOpen={deleteAlert} title="Confirm Delete" description="Are you sure you want to delete this role?" confirmLabel="Delete" cancelLabel="Cancel" colorScheme="red" />

                <CustomPagination
                    pageCount={pageCount}
                    handlePageClick={handlePageClick}
                    rowsPerPage={lazyParams.rows}
                    rowsPerPageOptions={[20, 50, 100, 200]}
                    setRowsPerPage={(value: number) =>
                        setLazyParams((prev) => ({ ...prev, rows: value, page: 0, first: 0 }))
                    }
                    totalRecords={totalCount}
                    currentPage={lazyParams.page}

                />
            </Box>
        </MyDiv>
    )
}
export default Pages;